/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { PublicInstrumentFromJSON, } from '../models/index';
/**
 *
 */
export class InstrumentsApi extends runtime.BaseAPI {
    /**
     * Public: the instrument groups a member can be assigned to.  Returns only the ``PublicInstrument`` fields (id/name/color) and only groups flagged ``is_instrument``, ordered by name - safe to expose unauthenticated. The response schema is a dedicated, closed shape (not a shared group schema) so this public surface cannot be widened by accident.
     * List Instruments
     */
    listInstrumentsApiV1InstrumentsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/instruments`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PublicInstrumentFromJSON));
        });
    }
    /**
     * Public: the instrument groups a member can be assigned to.  Returns only the ``PublicInstrument`` fields (id/name/color) and only groups flagged ``is_instrument``, ordered by name - safe to expose unauthenticated. The response schema is a dedicated, closed shape (not a shared group schema) so this public surface cannot be widened by accident.
     * List Instruments
     */
    listInstrumentsApiV1InstrumentsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listInstrumentsApiV1InstrumentsGetRaw(initOverrides);
            return yield response.value();
        });
    }
}
